/* eslint-disable import/prefer-default-export */
import { FunnelStep } from "@hypertune/shared-internal/src/types";
import toStartCase from "@hypertune/sdk/src/shared/helpers/toStartCase";
import { CommitContext } from "../../../../lib/types";

export function getStepLabel(
  commitContext: CommitContext,
  step: FunnelStep
): string {
  if (step.type === "FunnelEventStep") {
    return toStartCase(step.eventObjectTypeName);
  }
  const split = commitContext.splits[step.splitId];
  return split ? split.name : "Unknown split";
}
